import Repository from '../../Repository';

export class RoleRepository extends Repository {
    constructor() {
        super();
        this.resource = 'user-roles';
    }

    updateMfa({user_role_id}, data) {
        return this.put(`${user_role_id}/mfa`, data);
    }
}

const Roles = new RoleRepository();

export default Roles;

/**
 * @typedef UserRole
 * @type {object}
 * @property {number} user_role_id
 * @property {string} role_name
 * @property {string} role_type
 * @property {string} role_type_name
 * @property {string} role_description
 * @property {Permission[]} permissions
 * @property {User[]} users
 * @property {boolean} enforce_mfa
 */
